import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../services/api";
import Swal from "sweetalert2";
import "./Post.css";

const Post = () => {
  const [mediaType, setMediaType] = useState("image");
  const [mediaFile, setMediaFile] = useState(null);
  const [caption, setCaption] = useState("");
  const [existingMedia, setExistingMedia] = useState("");
  const { postId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (postId) {
      const fetchPostData = async () => {
        try {
          const response = await api.get(`/posts/${postId}`);
          const { post } = response.data;
          setCaption(post.caption);
          setExistingMedia(post.url);
          setMediaType(post.type);
        } catch (error) {
          console.error("Error fetching post data:", error);
        }
      };
      fetchPostData();
    }
  }, [postId]);

  const handleFileChange = (e) => {
    setMediaFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("file", mediaFile || existingMedia);
    formData.append("caption", caption);
    formData.append("type", mediaType);

    try {
      if (postId) {
        const response = await api.put(`/posts/${postId}`, formData);
        if (response.status === 200) {
          Swal.fire({
            icon: "success",
            title: "Post updated successfully!",
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            navigate("/posts"); // navigate after alert
          });
        }
      } else {
        const response = await api.post("/posts", formData);
        if (response.status === 201) {
          Swal.fire({
            icon: "success",
            title: "Your post has been published successfully!",
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            navigate("/posts"); // navigate after alert
          });
        }
      }
    } catch (error) {
      console.error("Error submitting post:", error);
      Swal.fire(
        "Error!",
        error.response?.data?.message ||
          "Oops! Something went wrong while submitting your post. Please try again.",
        "error"
      );
    }
  };

  return (
    <div className="post-container">
      <h2>{postId ? "Edit Post" : "Add Post"}</h2>
      <form onSubmit={handleSubmit} className="post-form">
        <div className="form-group">
          <label htmlFor="media-type">Media Type</label>
          <select
            id="media-type"
            value={mediaType}
            onChange={(e) => setMediaType(e.target.value)}
          >
            <option value="image">Quotes</option>
            <option value="video">Video</option>
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="media-file">Media Upload</label>
          <input
            type="file"
            id="media-file"
            accept={mediaType === "image" ? "image/*" : "video/*"}
            onChange={handleFileChange}
          />
          {existingMedia && (
            <div className="existing-media">
              <p>Current Media:</p>
              <img src={existingMedia} alt="Current media" width="200" />
            </div>
          )}
        </div>

        <div className="form-group">
          <label htmlFor="caption">Caption</label>
          <input
            type="text"
            id="caption"
            value={caption}
            onChange={(e) => setCaption(e.target.value)}
          />
        </div>

        <button type="submit" className="btn-submit">
          {postId ? "Update Post" : "Add Post"}
        </button>
      </form>
    </div>
  );
};

export default Post;
